import Layout from "./Layout.jsx";
import Landing from "./Landing";

import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import { TermsOfUsePopup, PrivacyPolicyPopup } from "@/components/popups";

// Custom event name for opening privacy modal (must match the one in CookieBanner)
const OPEN_PRIVACY_MODAL_EVENT = "jobpool:openPrivacyModal";

const PAGES = {
    Landing: Landing,
}

function _getCurrentPage(url) {
    if (url.endsWith('/')) {
        url = url.slice(0, -1);
    }

    let urlLastPart = url.split('/').pop();

    if (urlLastPart.includes('?')) {
        urlLastPart = urlLastPart.split('?')[0];
    }

    const pageName = Object.keys(PAGES).find(page => page.toLowerCase() === urlLastPart.toLowerCase());
    return pageName || Object.keys(PAGES)[0];
}

// Create a wrapper component that uses useLocation inside the Router context
function PagesContent() {
    const location = useLocation();
    const navigate = useNavigate();
    const currentPage = _getCurrentPage(location.pathname);
    
    // State for controlling the visibility of modals
    const [showTerms, setShowTerms] = useState(false);
    const [showPrivacy, setShowPrivacy] = useState(false);
    
    // Handle modal state based on URL
    useEffect(() => {
        // Check if the URL path includes /terms or /privacy
        if (location.pathname.includes('/terms')) {
            setShowTerms(true);
        } else {
            setShowTerms(false);
        }
        
        if (location.pathname.includes('/privacy')) {
            setShowPrivacy(true);
        } else {
            setShowPrivacy(false);
        }
    }, [location.pathname]);
    
    // Listen for custom event to open privacy modal
    useEffect(() => {
        const handleOpenPrivacyModal = () => {
            setShowPrivacy(true);
        };
        
        // Add event listener
        window.addEventListener(OPEN_PRIVACY_MODAL_EVENT, handleOpenPrivacyModal);
        
        // Clean up
        return () => {
            window.removeEventListener(OPEN_PRIVACY_MODAL_EVENT, handleOpenPrivacyModal);
        };
    }, []);
    
    // Handle modal close actions
    const handleCloseTerms = () => {
        setShowTerms(false);
        // Go back to previous URL without the /terms part
        navigate(-1);
    };
    
    const handleClosePrivacy = () => {
        setShowPrivacy(false);
        // Go back to previous URL without the /privacy part
        navigate(-1);
    };
    
    return (
        <Layout currentPageName={currentPage}>
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/Landing" element={<Landing />} />
                {/* Modal routes - they render the same main page but with modals */}
                <Route path="/terms" element={<Landing />} />
                <Route path="/privacy" element={<Landing />} />
            </Routes>
            
            {/* Render modals based on state */}
            <TermsOfUsePopup isOpen={showTerms} onClose={handleCloseTerms} />
            <PrivacyPolicyPopup isOpen={showPrivacy} onClose={handleClosePrivacy} />
        </Layout>
    );
}

export default function Pages() {
    return (
        <Router>
            <PagesContent />
        </Router>
    );
}